module.exports = __webpack_public_path__ + "img/menu-14.804fd315.jpg";